// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Switch from 'react-switch';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';

type ToggleSwitchProps = {
  checked: boolean,
  onChange: Function,
  theme?: ThemeType,
};

const initialValues: ToggleSwitchProps = {
  checked: false,
  theme: DefaultTheme,
  onChange: () => {},
};

export const ToggleSwitch = (props: ToggleSwitchProps) => (
  <Switch {...props}
    uncheckedIcon={false}
    checkedIcon={false}
    width={64}
    handleDiameter={22}
    // TODO: BOX_SHADOW should be SHADES_OF_BLACK_200
    // $FlowIgnore theme IS provided
    boxShadow={`0 0 2px 1px ${props.theme.ThemeColors.BOX_SHADOW.hex}`}
    height={16}>
  </Switch>
);

ToggleSwitch.defaultProps = initialValues;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/ToggleSwitch.js